export default "__VITE_ASSET__CPc_heb$__"